/* BISD v2 product page: formula toggle, shade dots, bundle tiles, CTA, sticky bar, gallery.
   Each shade is its own Shopify product, so switching swaps product data from the JSON the section
   renders (live prices, stock, images) and updates the URL with history.replaceState. No reload.
   Prices shown before adding use Shopify's per-unit rounding for the multi-buy (floor of pct% per unit);
   the cart drawer then shows the cart's own totals. */
(() => {
  const el = document.querySelector('[data-pdp]');
  if (!el) return;
  let data;
  try { data = JSON.parse(el.querySelector('[data-pdp-json]').textContent); } catch (error) { return; }

  const $ = (selector) => el.querySelector(selector);
  const $$ = (selector) => Array.from(el.querySelectorAll(selector));
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (pence) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: data.currency || 'GBP' }).format(pence / 100);
  const esc = (text) => String(text).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const form = document.getElementById('v2-form');
  const isFoundation = data.family === 'foundation';
  const FORMULA = { o: 'Original', c: 'Oil Control' };
  const HINT = { o: 'For normal to dry skin', c: 'For oily and combination skin' };
  const TITLE = { o: 'Oxygenating Foundation', c: 'Oil Control Foundation' };

  const params = new URLSearchParams(window.location.search);
  const kit = params.get('kit');
  const state = {
    f: data.formula || 'o',
    key: data.current,
    picked: !params.has('choose') || !data.options.length || data.family === 'other',
    tile: '2',
    second: 'same',
    third: 'same',
    alt: null,
    conc: null
  };
  const hasTile = (tile) => Boolean($(`[data-tile="${tile}"]`));
  state.tile = String(data.defaultTile || '2');
  if (['1', '2', '3', 'set'].includes(kit)) state.tile = kit;
  if (kit === 'duo') { state.tile = '2'; state.second = 'other'; }
  if (!hasTile(state.tile)) state.tile = hasTile(String(data.defaultTile || '2')) ? String(data.defaultTile || '2') : (hasTile('2') ? '2' : '1');

  const opt = (key) => data.options.find((o) => o.key === key);
  const prodOf = (key, f) => { const o = opt(key); const h = o && o[f]; return h ? data.p[h] : null; };
  const cur = () => prodOf(state.key, state.f);
  const other = () => (state.f === 'o' ? 'c' : 'o');
  const partner = () => (isFoundation ? prodOf(state.key, other()) : null);
  const featured = (o, f) => (f === 'c' ? o.fc : o.fo);
  /* Multi-buy tiers, as Shopify applies them: % off each unit, rounded down to the penny. The 3+ tier has a
     real end date (Europe/London) and falls back to the 2+ % automatically when it passes. */
  const t3End = data.tier3 && data.tier3.end && window.BISD && window.BISD.parseLondon ? window.BISD.parseLondon(data.tier3.end) : NaN;
  let t3Gone = false;
  const t3on = () => Boolean(!t3Gone && data.tier3 && data.tier3.pct > 0 && (!data.tier3.end || !(Date.now() >= t3End)));
  const t1End = data.tier1 && data.tier1.end && window.BISD && window.BISD.parseLondon ? window.BISD.parseLondon(data.tier1.end) : NaN;
  const t1on = () => Boolean(!t3Gone && data.tier1 && data.tier1.pct > 0 && (!data.tier1.end || !(Date.now() >= t1End)));
  const pctFor = (qty) => {
    let out = qty >= 1 && t1on() ? data.tier1.pct : 0;
    if (qty >= 2 && data.multibuy) out = Math.max(out, data.pct);
    if (qty >= 3 && t3on()) out = Math.max(out, data.tier3.pct);
    return out;
  };
  const unit = (price, qty) => price - Math.floor((price * pctFor(qty)) / 100);
  const concealer = (key) => { const c = data.concealers.find((k) => k.key === key); return c ? Object.assign({ key: c.key, name: c.name }, data.p[c.h]) : null; };

  /* ---------- Gallery ---------- */
  const track = $('[data-gallery-track]');
  const dotsWrap = $('[data-gallery-dots]');
  let galleryKey = '';
  /* Trimmed images carry height= too (square, cropped from the top); scale both. */
  const sized = (u, w) => u.replace(/width=\d+/, `width=${w}`).replace(/height=\d+/, `height=${w}`);
  const srcset = (u) => [450, 600, 750, 900].map((w) => `${sized(u, w)} ${w}w`).join(', ');
  function setDots(count) {
    dotsWrap.innerHTML = Array.from({ length: count }, (_, i) => `<button type="button" class="v2-gallery__dot${i === 0 ? ' is-active' : ''}" aria-label="Image ${i + 1} of ${count}"${i === 0 ? ' aria-current="true"' : ''}></button>`).join('');
    dotsWrap.parentElement.hidden = count < 2;
  }
  function activeDot(index) {
    dotsWrap.querySelectorAll('.v2-gallery__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
    });
  }
  let slideObserver;
  function observeSlides() {
    if (!('IntersectionObserver' in window)) return;
    if (slideObserver) slideObserver.disconnect();
    slideObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) activeDot(Array.from(track.children).indexOf(entry.target)); });
    }, { root: track, threshold: 0.6 });
    Array.from(track.children).forEach((slide) => slideObserver.observe(slide));
  }
  function renderGallery(product) {
    if (!product || !track) return;
    const stems = product.img.filter((s) => data.img[s]);
    const key = stems.join('|');
    if (key === galleryKey) return;
    galleryKey = key;
    const gallery = $('[data-gallery]');
    gallery.classList.add('is-loading');
    track.innerHTML = stems.map((s, i) => {
      const im = data.img[s];
      return `<li class="v2-gallery__slide"><img class="v2-gallery__img" src="${esc(sized(im.u, 900))}" srcset="${esc(srcset(im.u))}" sizes="(min-width: 990px) 56vw, 100vw" alt="${esc(im.a)}" width="900" height="${Math.round(900 * (im.r || 1.25))}" ${i === 0 ? 'fetchpriority="high"' : 'loading="lazy"'}></li>`;
    }).join('');
    track.scrollLeft = 0;
    setDots(stems.length);
    observeSlides();
    const first = track.querySelector('img');
    const done = () => gallery.classList.remove('is-loading');
    if (!first || first.complete) done(); else { first.addEventListener('load', done, { once: true }); first.addEventListener('error', done, { once: true }); window.setTimeout(done, 1500); }
  }
  if (track) {
    galleryKey = '';
    const initial = cur();
    if (initial) galleryKey = initial.img.filter((s) => data.img[s]).join('|');
    observeSlides();
    dotsWrap.addEventListener('click', (event) => {
      const dot = event.target.closest('.v2-gallery__dot');
      if (!dot) return;
      const index = Array.from(dotsWrap.children).indexOf(dot);
      track.scrollTo({ left: index * track.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
    });
    const step = (dir) => track.scrollBy({ left: dir * track.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
    const prev = $('[data-gallery-prev]');
    const next = $('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
    });
  }

  /* ---------- Shade / size options ---------- */
  const shadesWrap = $('[data-shades]');
  function offered(f) {
    const list = data.options.filter((o) => {
      const p = o[f] ? data.p[o[f]] : null;
      if (!p) return false;
      if (o.key === state.key && f === state.f) return true;
      return p.available && featured(o, f);
    });
    /* Concealer: most popular first (Theme settings order). */
    if (data.family === 'concealer') list.sort((a, b) => (a.rank || 99) - (b.rank || 99));
    return list;
  }
  function dotHtml(o, f, name, checked, extraClass = '') {
    const p = data.p[o[f]];
    const sold = p && !p.available;
    const id = `v2-${name}-${o.key}`;
    if (data.family === 'hydro') {
      return `<input class="v2-dot__input" type="radio" name="${name}" id="${id}" value="${esc(o.key)}"${checked ? ' checked' : ''}><label class="v2-size" for="${id}">${esc(o.name)}</label>`;
    }
    return `<input class="v2-dot__input" type="radio" name="${name}" id="${id}" value="${esc(o.key)}"${checked ? ' checked' : ''}><label class="v2-dot${sold ? ' is-soldout' : ''}${extraClass}" for="${id}" style="--dot: ${esc(o.hex || '#D6B29A')}" title="${esc(o.name)}"><span class="visually-hidden">${esc(o.name)}${sold ? ', sold out' : ''}</span></label>`;
  }
  function renderShades() {
    if (!shadesWrap) return;
    const list = offered(state.f);
    let html = list.map((o) => dotHtml(o, state.f, 'shade', state.picked && o.key === state.key)).join('');
    if (data.family === 'concealer') {
      const more = data.options.filter((o) => !list.includes(o) && data.p[o.o] && data.p[o.o].available);
      if (more.length) html += `<details class="v2-more"${more.some((o) => o.key === state.key) ? ' open' : ''}><summary>More shades</summary><div class="v2-dots">${more.map((o) => dotHtml(o, 'o', 'shade', state.picked && o.key === state.key)).join('')}</div></details>`;
    }
    shadesWrap.innerHTML = html;
    shadesWrap.setAttribute('role', 'radiogroup');
  }
  function shadeLabel() {
    const label = $('[data-shade-label]');
    if (!label) return;
    if (!state.picked) { label.textContent = ': choose one'; return; }
    const o = opt(state.key);
    if (!o) return;
    let text = `: ${o.name}`;
    if (isFoundation && state.f === 'o' && o.depth) text += ` · ${o.depth}, ${o.tone}`;
    if (data.family === 'concealer' && o.tone) text += ` · ${o.tone}`;
    label.textContent = text;
  }
  function note(text, tryKeys) {
    const box = $('[data-shade-note]');
    if (!box) return;
    if (!text) { box.hidden = true; box.textContent = ''; return; }
    box.hidden = false;
    box.innerHTML = esc(text) + (tryKeys && tryKeys.length ? ' ' + tryKeys.map((k) => `<button type="button" class="v2-linkbtn" data-try="${esc(k)}">${esc(opt(k).name)}</button>`).join(' or ') : '');
  }
  /* Nearest offered shades by brand chart order (not a colour match). */
  function nearest(key, f, count) {
    const order = data.options.map((o) => o.key);
    const at = order.indexOf(key);
    const pool = offered(f).filter((o) => o.key !== key && data.p[o[f]].available).map((o) => o.key);
    return pool.sort((a, b) => Math.abs(order.indexOf(a) - at) - Math.abs(order.indexOf(b) - at)).slice(0, count);
  }

  /* ---------- Concealer picker (full set) ---------- */
  const concWrap = $('[data-conc]');
  function renderConcealers() {
    if (!concWrap || !data.concealers.length) return;
    const avail = data.concealers.filter((c) => data.p[c.h] && data.p[c.h].available);
    const first = avail.filter((c) => c.fo);
    const more = avail.filter((c) => !c.fo);
    const dot = (c) => `<input class="v2-dot__input" type="radio" name="conc" id="v2-conc-${c.key}" value="${esc(c.key)}"${state.conc === c.key ? ' checked' : ''}><label class="v2-dot" for="v2-conc-${c.key}" style="--dot: ${esc(c.hex)}" title="${esc(c.name)}"><span class="visually-hidden">${esc(c.name)}</span></label>`;
    concWrap.innerHTML = first.map(dot).join('') + (more.length ? `<details class="v2-more"><summary>More shades</summary><div class="v2-dots v2-dots--sm">${more.map(dot).join('')}</div></details>` : '');
  }

  /* ---------- Tiles, CTA, sticky ----------
     Struck prices are always the shop's own current price x quantity (never a compare-at).
     Totals here are previews; the drawer then shows the cart's own numbers (Shopify is authoritative). */
  function setText(node, text) {
    if (!node || node.textContent === text) return;
    node.textContent = text;
    if (!reduce()) { node.classList.remove('v2-swap'); void node.offsetWidth; node.classList.add('v2-swap'); }
  }
  /* Count a money figure from its previous value (300ms, ease-out); instant with reduced motion. */
  function countTo(node, to) {
    if (!node) return;
    const from = Number(node.dataset.v || NaN);
    node.dataset.v = String(to);
    if (reduce() || !Number.isFinite(from) || from === to) { node.textContent = fmt(to); return; }
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / 300);
      const e = 1 - Math.pow(1 - t, 3);
      node.textContent = fmt(Math.round(from + (to - from) * e));
      if (t < 1 && node.dataset.v === String(to)) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    /* rAF pauses in background tabs; make sure the final figure is always shown. */
    window.setTimeout(() => { if (node.dataset.v === String(to)) node.textContent = fmt(to); }, 400);
  }
  /* Struck "was" + bold "now" + optional "Save £x" pill, with one screen-reader sentence. */
  function priceBox(box, q, { save = true } = {}) {
    if (!box || !q) return;
    const struck = q.was > q.total;
    let html = box.querySelector('.v2-pricebox');
    if (!html) {
      box.innerHTML = '<span class="v2-pricebox"><span class="visually-hidden" data-sr></span><span class="v2-pricebox__in" aria-hidden="true"><s class="v2-was" data-was></s><strong class="v2-now" data-now></strong></span><span class="v2-savepill" data-save aria-hidden="true"></span></span>';
      html = box.querySelector('.v2-pricebox');
    }
    const wasEl = html.querySelector('[data-was]');
    const prevWas = wasEl.dataset.v;
    wasEl.hidden = !struck;
    if (struck) {
      wasEl.textContent = fmt(q.was);
      wasEl.dataset.v = String(q.was);
      if (prevWas !== String(q.was) && !reduce()) { wasEl.classList.remove('is-draw'); void wasEl.offsetWidth; wasEl.classList.add('is-draw'); }
    }
    countTo(html.querySelector('[data-now]'), q.total);
    const pill = html.querySelector('[data-save]');
    pill.hidden = !(struck && save);
    if (struck && save) pill.textContent = `Save ${fmt(q.was - q.total)}`;
    html.querySelector('[data-sr]').textContent = struck ? `Was ${fmt(q.was)}, now ${fmt(q.total)}, save ${fmt(q.was - q.total)}` : fmt(q.total);
  }
  function quote(tile) {
    const p = cur();
    if (!p) return null;
    if (tile === '1') return { n: 1, total: unit(p.price, 1), was: p.price, each: unit(p.price, 1), items: [{ id: p.id, quantity: 1 }] };
    if (tile === '2') {
      const mate = partner();
      if (state.second === 'other' && mate && mate.available) {
        return { n: 2, total: unit(p.price, 2) + unit(mate.price, 2), was: p.price + mate.price, items: [{ id: p.id, quantity: 1 }, { id: mate.id, quantity: 1 }], mixed: true };
      }
      if (state.second === 'shade') {
        const alt = state.alt ? prodOf(state.alt, state.f) : null;
        if (!alt || !alt.available) return { n: 2, total: unit(p.price, 2) * 2, was: p.price * 2, each: unit(p.price, 2), items: [], needsAlt: true };
        return { n: 2, total: unit(p.price, 2) + unit(alt.price, 2), was: p.price + alt.price, items: [{ id: p.id, quantity: 1 }, { id: alt.id, quantity: 1 }], mix: 'shade' };
      }
      return { n: 2, total: unit(p.price, 2) * 2, was: p.price * 2, each: unit(p.price, 2), items: [{ id: p.id, quantity: 2 }], short: typeof p.q === 'number' && p.q < 2 };
    }
    if (tile === '3') {
      const lowQ = (x, n) => typeof x.q === 'number' && x.q < n;
      if (state.third === 'other') {
        const mate = partner();
        if (mate && mate.available) return { n: 3, total: unit(p.price, 3) + unit(mate.price, 3) * 2, was: p.price + mate.price * 2, items: [{ id: p.id, quantity: 1 }, { id: mate.id, quantity: 2 }], mix: 'other', short: lowQ(mate, 2) };
      }
      if (state.third === 'shade') {
        const alt = state.alt ? prodOf(state.alt, state.f) : null;
        if (!alt || !alt.available) return { n: 3, total: unit(p.price, 3) * 3, was: p.price * 3, each: unit(p.price, 3), items: [], needsAlt: true };
        return { n: 3, total: unit(p.price, 3) + unit(alt.price, 3) * 2, was: p.price + alt.price * 2, items: [{ id: p.id, quantity: 1 }, { id: alt.id, quantity: 2 }], mix: 'shade', short: lowQ(alt, 2) };
      }
      return { n: 3, total: unit(p.price, 3) * 3, was: p.price * 3, each: unit(p.price, 3), items: [{ id: p.id, quantity: 3 }], short: lowQ(p, 3) };
    }
    if (tile === 'set' && data.brush) {
      const c = concealer(state.conc) || concealer('n1') || concealer((data.concealers.find((k) => data.p[k.h] && data.p[k.h].available) || {}).key);
      if (!c) return null;
      const items = [{ id: p.id, quantity: 1 }, { id: data.brush.id, quantity: 1 }];
      if (state.conc) items.splice(1, 0, { id: c.id, quantity: 1 });
      return { n: 3, total: unit(p.price, 3) + unit(c.price, 3) + unit(data.brush.price, 3), was: p.price + c.price + data.brush.price, items, needsConc: !state.conc };
    }
    return null;
  }
  function freeDelivery(total) { return data.shipping && total >= data.threshold; }
  const NOUN = Array.isArray(data.noun) ? data.noun : (isFoundation ? ['bottle', 'bottles'] : ['item', 'items']);
  function renderPriceRow() {
    const p = cur();
    const row = $('[data-price-row]');
    if (!row || !p) return;
    const until = row.dataset.until ? ` ${row.dataset.until}` : '';
    const one = unit(p.price, 1);
    const offOne = one < p.price;
    countTo(row.querySelector('[data-row-price]'), one);
    const wasEl = row.querySelector('[data-row-was]');
    if (wasEl) { wasEl.hidden = !offOne; wasEl.textContent = fmt(p.price); }
    const t1pill = row.querySelector('[data-row-t1]');
    if (t1pill) { t1pill.hidden = !offOne; t1pill.textContent = `${pctFor(1)}% off${until}`; }
    const sr = row.querySelector('[data-row-sr]');
    if (sr) sr.textContent = offOne ? `Was ${fmt(p.price)}, now ${fmt(one)}, ${pctFor(1)}% off${until}` : fmt(one);
    /* "each with N+": the best multi-buy line; hidden when this shade has fewer than N in stock. */
    const n = hasTile('3') && pctFor(3) > pctFor(2) ? 3 : 2;
    const pct = pctFor(n);
    const enough = !(typeof p.q === 'number' && p.q < n);
    const from = row.querySelector('[data-row-from]');
    if (from) {
      from.hidden = !(pct && enough);
      row.querySelector('[data-row-each]').textContent = fmt(unit(p.price, n));
      row.querySelector('[data-row-n]').textContent = String(n);
      row.querySelector('[data-row-pct]').textContent = String(pct);
      const u = row.querySelector('[data-row-until]');
      if (u) u.hidden = !(n === 3 && until);
    }
  }
  function renderTiles() {
    const p = cur();
    const tilesWrap = $('[data-tiles]');
    if (tilesWrap) tilesWrap.hidden = !(p && p.available);
    ['1', '2', '3', 'set'].forEach((tile) => {
      const box = $(`[data-tile="${tile}"]`);
      if (!box) return;
      const q = quote(tile);
      box.querySelector('.v2-tile__input').checked = state.tile === tile;
      box.classList.toggle('is-on', state.tile === tile);
      const badge = $(`[data-badge="${tile}"]`);
      if (badge) { const pc = pctFor(tile === '1' ? 1 : tile === '2' ? 2 : 3); badge.hidden = !pc; const temp = tile === '1' ? pc > 0 : pc > (data.multibuy ? data.pct : 0); badge.textContent = `${pc}% OFF${badge.dataset.until && temp ? ` ${badge.dataset.until}` : ''}`; const chips = badge.closest('.v2-tile__chips'); if (chips && tile === '1') chips.hidden = !pc; }
      if (!q) return;
      priceBox($(`[data-pricebox="${tile}"]`), q);
      const meta = $(`[data-meta="${tile}"]`);
      const name = opt(state.key) ? opt(state.key).name : '';
      if (meta) {
        let text = '';
        if (tile === '2') {
          if (q.mixed) text = `${name} in both formulas`;
          else if (q.mix === 'shade') text = `${name} + ${opt(state.alt).name}`;
          else if (q.needsAlt) text = `Pick the 2nd shade`;
          else text = q.each < p.price ? `${fmt(q.each)} per ${NOUN[0]}` : '';
        }
        if (tile === '3') {
          if (q.mix === 'other') text = `1 ${FORMULA[state.f]} + 2 ${FORMULA[other()]}`;
          else if (q.mix === 'shade') text = `1 ${name} + 2 ${opt(state.alt).name}`;
          else if (q.needsAlt) text = `Pick the shade for ${NOUN[1]} 2 and 3`;
          else text = q.each < p.price ? `${fmt(q.each)} per ${NOUN[0]}` : '';
        }
        if (tile !== '1') setText(meta, text);
      }
    });
    const perk = $('[data-perk]');
    const picked = quote(state.tile);
    if (perk) perk.hidden = !(p && p.available && picked && freeDelivery(picked.total));
    $$('[data-lowest]').forEach((n) => { n.hidden = !t3on(); });
    const mate = partner();
    const mateOk = Boolean(mate && mate.available);
    [['#v2-s-other', 'second'], ['#v2-x-other', 'third']].forEach(([sel, key]) => {
      const input = el.querySelector(sel);
      if (!input) return;
      input.disabled = !mateOk;
      if (!mateOk && state[key] === 'other') state[key] = 'same';
      el.querySelectorAll(`input[name="${key}"]`).forEach((r) => { r.checked = r.value === state[key]; });
    });
    $$('[data-other-name]').forEach((lab) => { lab.textContent = FORMULA[other()]; });
    renderAlt();
    const thumb = $('[data-set-thumb] img');
    if (thumb && p && p.thumb) { thumb.src = p.thumb; thumb.removeAttribute('srcset'); }
    const concLabel = $('[data-conc-label]');
    if (concLabel) concLabel.textContent = state.conc ? `: ${concealer(state.conc).name}` : '';
  }
  /* Other shade for bottles 2 and 3: offered, in-stock shades of the same formula. */
  function renderAlt() {
    $$('[data-alt]').forEach((wrap) => {
      const tile = wrap.dataset.altTile || '3';
      const on = tile === '2' ? state.second === 'shade' : state.third === 'shade';
      wrap.hidden = !on;
      if (!on) { if (wrap.dataset.html) { wrap.innerHTML = ''; wrap.dataset.html = ''; } return; }
      const pool = data.family === 'concealer' ? data.options.slice().sort((a, b) => (a.rank || 99) - (b.rank || 99)) : offered(state.f);
      const list = pool.filter((o) => o.key !== state.key && data.p[o[state.f]] && data.p[o[state.f]].available);
      if (state.alt && !list.some((o) => o.key === state.alt)) state.alt = null;
      const pre = tile === '2' ? 'v2-alt2-' : 'v2-alt-';
      const html = list.map((o) => `<input class="v2-dot__input" type="radio" name="alt" id="${pre}${o.key}" value="${esc(o.key)}"${state.alt === o.key ? ' checked' : ''}><label class="v2-dot" for="${pre}${o.key}" style="--dot: ${esc(o.hex || '#D6B29A')}" title="${esc(o.name)}"><span class="visually-hidden">${esc(o.name)}</span></label>`).join('');
      if (wrap.dataset.html !== html) { wrap.innerHTML = html; wrap.dataset.html = html; }
    });
  }
  function ctaMode() {
    const p = cur();
    if (!state.picked) return { mode: 'choose', label: isFoundation || data.family === 'concealer' ? 'Choose your shade' : 'Choose your size' };
    if (!p || !p.available) return { mode: 'soldout', label: 'Sold out' };
    const q = quote(state.tile);
    if (!q) return { mode: 'soldout', label: 'Unavailable' };
    if (q.needsConc) return { mode: 'conc', label: 'Choose concealer shade' };
    if (q.needsAlt) return { mode: 'alt', label: state.tile === '2' ? 'Choose the 2nd shade' : `Choose shade for ${NOUN[1]} 2 and 3` };
    if (q.short) return { mode: 'soldout', short: true, label: 'Not enough stock for this bundle' };
    let verb = 'Add to basket';
    if (state.tile === '2') verb = q.mixed || q.mix ? 'Add both to basket' : 'Add 2 to basket';
    if (state.tile === '3') verb = 'Add 3 to basket';
    if (state.tile === 'set') verb = 'Add set to basket';
    return { mode: 'add', verb, q };
  }
  const cta = $('[data-cta]');
  const ctaLabel = $('[data-cta-label]');
  const status = $('[data-status]');
  const express = $('[data-express]');
  const sticky = $('[data-sticky]');
  /* Button label: verb · struck was · bold now (screen readers hear "was ..., now ..."). */
  function priceLabel(node, verb, q) {
    const struck = q.was > q.total;
    const html = `${esc(verb)} · ${struck ? `<span class="visually-hidden">was ${fmt(q.was)}, now </span><s class="v2-was v2-was--on-dark" aria-hidden="true">${fmt(q.was)}</s> ` : ''}<strong>${fmt(q.total)}</strong>`;
    if (node.dataset.html === html) return;
    node.dataset.html = html;
    node.innerHTML = html;
    if (!reduce()) { node.classList.remove('v2-swap'); void node.offsetWidth; node.classList.add('v2-swap'); }
  }
  function plainLabel(node, text) { node.dataset.html = ''; setText(node, text); }
  function renderCta() {
    const m = ctaMode();
    if (m.mode === 'add') priceLabel(ctaLabel, m.verb, m.q); else plainLabel(ctaLabel, m.label);
    if (m.mode === 'soldout') cta.setAttribute('aria-disabled', 'true'); else cta.removeAttribute('aria-disabled');
    cta.dataset.mode = m.mode;
    const p = cur();
    const simple = m.mode === 'add' && m.q.items.length === 1;
    if (express) express.hidden = !simple || !p || String(p.id) !== String(data.renderedId);
    if (form && p) {
      form.querySelector('[data-variant-input]').value = p.id;
      form.querySelector('[data-qty-input]').value = simple ? m.q.items[0].quantity : 1;
    }
    if (sticky) {
      const o = opt(state.key);
      sticky.querySelector('[data-sticky-dot]').style.setProperty('--dot', o && o.hex ? o.hex : 'var(--c-sunken)');
      sticky.querySelector('[data-sticky-name]').textContent = state.picked && o ? (['other', 'skincare', 'brush'].includes(data.family) ? $('[data-title]').textContent : o.name) : 'Choose your shade';
      const tileName = { '1': `1 ${NOUN[0]}`, '2': m.q && m.q.mixed ? 'Original + Oil Control' : `2 ${NOUN[1]}`, '3': `3 ${NOUN[1]}`, set: 'The full set' }[state.tile];
      const hideTile = !$('[data-tiles]');
      const metaEl = sticky.querySelector('[data-sticky-meta]');
      const metaHtml = `${esc(`${isFoundation ? FORMULA[state.f] + ' · ' : ''}${hideTile ? '' : tileName}`)}${m.q && m.q.was > m.q.total ? ` <span class="v2-savepill v2-savepill--xs" aria-hidden="true">-${pctFor(m.q.n)}%</span>` : ''}`;
      if (metaEl.dataset.html !== metaHtml) { metaEl.innerHTML = metaHtml; metaEl.dataset.html = metaHtml; }
      const lab = sticky.querySelector('[data-sticky-label]');
      if (m.mode === 'add') priceLabel(lab, 'Add', m.q); else plainLabel(lab, m.mode === 'soldout' ? (m.short ? 'Low stock' : 'Sold out') : 'Choose');
    }
  }
  /* Low stock: live inventory, only when Shopify tracks it and overselling is off (q is null otherwise). */
  const lowBox = $('[data-low]');
  function renderLow() {
    if (!lowBox) return;
    const p = cur();
    const max = Number(data.lowStock || 0);
    const q = p && typeof p.q === 'number' ? p.q : null;
    const show = Boolean(state.picked && p && p.available && max > 0 && q !== null && q > 0 && q <= max);
    lowBox.hidden = !show;
    if (!show) return;
    const o = opt(state.key);
    const named = o && (isFoundation || data.family === 'concealer');
    lowBox.querySelector('[data-low-text]').textContent = `Only ${q} left${named ? ` in ${o.name}` : ''}`;
  }
  /* Pairing cards: "Add both" = this page's current product + the pairing, priced as the 2-item tier. */
  function renderPairs() {
    const p = cur();
    const withMe = Boolean(state.picked && p && p.available);
    $$('[data-pair]').forEach((card) => {
      const sel = card.querySelector('select[name="id"]');
      const opt2 = sel ? sel.selectedOptions[0] : null;
      const price = Number(opt2 && opt2.dataset.price ? opt2.dataset.price : card.dataset.pairPrice);
      if (!Number.isFinite(price)) return;
      const box = card.querySelector('[data-pair-box]');
      const noteEl = card.querySelector('[data-pair-note]');
      const label = card.querySelector('[data-pair-btn-label]');
      let was; let now; let note = '';
      if (withMe) {
        const pc = pctFor(2);
        was = p.price + price;
        now = unit(p.price, 2) + unit(price, 2);
        if (pc) note = `With this ${data.pairNoun || 'item'} · ${pc}% off both`;
        if (freeDelivery(now)) note += note ? ' + free UK delivery' : 'Free UK delivery';
      } else {
        was = price;
        now = unit(price, 1);
        const pc = pctFor(1);
        if (pc) note = `${pc}% off`;
      }
      if (noteEl) { noteEl.textContent = note; noteEl.hidden = !note; }
      if (label) label.textContent = withMe ? 'Add both' : 'Add';
      if (box) {
        const struck = was > now;
        box.innerHTML = `${withMe ? '<span class="v2-pair__label">Both for </span>' : ''}<span class="v2-strike">${struck ? `<span class="visually-hidden">Was ${fmt(was)}, now ${fmt(now)}</span><span class="v2-strike__in" aria-hidden="true"><s class="v2-was">${fmt(was)}</s> <strong class="v2-now">${fmt(now)}</strong></span>` : `<strong class="v2-now">${fmt(now)}</strong>`}</span>`;
      }
    });
  }
  function renderAll() { renderTiles(); renderCta(); shadeLabel(); renderLow(); renderPriceRow(); renderPairs(); }
  document.addEventListener('bisd:t3end', () => { t3Gone = true; renderAll(); });

  /* ---------- Swapping product (shade / formula / size) ---------- */
  function syncUrl(p) {
    const next = new URL(p.url, window.location.origin);
    params.forEach((value, key) => { if (!['choose', 'shade', 'kit', 'variant'].includes(key)) next.searchParams.set(key, value); });
    if (!state.picked) next.searchParams.set('choose', '1');
    try { window.history.replaceState(window.history.state, '', next.pathname + next.search + next.hash); } catch (error) { /* ignore */ }
  }
  function swap(key, f, { focusName } = {}) {
    const p = prodOf(key, f);
    if (!p) return;
    const prev = cur();
    state.key = key;
    state.f = f;
    if (prev && document.title.includes(prev.title)) document.title = document.title.replace(prev.title, p.title);
    syncUrl(p);
    renderGallery(p);
    const title = $('[data-title]');
    if (isFoundation && title) { title.textContent = TITLE[f]; }
    const hint = $('[data-formula-hint]');
    if (hint) hint.textContent = HINT[f];
    const radio = el.querySelector(`input[name="formula"][value="${f}"]`);
    if (radio) radio.checked = true;
    if (isFoundation) document.dispatchEvent(new CustomEvent('bisd:formula', { detail: { f } }));
    renderShades();
    if (!p.available && state.picked) {
      const tries = nearest(key, f, 2);
      note(`${opt(key).name} is sold out.${tries.length ? ' Try' : ''}`, tries);
    }
    renderAll();
    if (focusName) {
      const input = el.querySelector(`input[name="${focusName}"][value="${CSS.escape(key)}"]`);
      if (input) input.focus({ preventScroll: true });
    }
  }

  el.addEventListener('change', (event) => {
    const t = event.target;
    if (t.name === 'formula') {
      const f = t.value;
      const same = prodOf(state.key, f);
      if (same && same.available) { note(''); swap(state.key, f); return; }
      const near = nearest(state.key, f, 1)[0];
      const fromName = opt(state.key) ? opt(state.key).name : 'That shade';
      if (near) {
        swap(near, f);
        note(`No ${FORMULA[f]} ${fromName} right now. Showing ${opt(near).name}.`);
      } else {
        el.querySelectorAll('input[name="formula"]').forEach((r) => { r.checked = r.value === state.f; });
        note(`${FORMULA[f]} is not available right now.`);
      }
      return;
    }
    if (t.name === 'shade') {
      state.picked = true;
      note('');
      swap(t.value, state.f, { focusName: 'shade' });
      return;
    }
    if (t.name === 'bundle') { state.tile = t.value; status.textContent = ''; renderAll(); return; }
    if (t.name === 'second') { state.second = t.value; state.tile = '2'; renderAll(); return; }
    if (t.name === 'third') { state.third = t.value; state.tile = '3'; renderAll(); return; }
    if (t.name === 'alt') { state.alt = t.value; const w = t.closest('[data-alt]'); state.tile = w && w.dataset.altTile === '2' ? '2' : '3'; status.textContent = ''; renderAll(); return; }
    if (t.closest && t.closest('[data-pair]')) { renderPairs(); return; }
    if (t.name === 'conc') {
      state.conc = t.value;
      state.tile = 'set';
      renderAll();
    }
  });
  el.addEventListener('click', (event) => {
    const tryBtn = event.target.closest('[data-try]');
    if (tryBtn) { state.picked = true; note(''); swap(tryBtn.dataset.try, state.f, { focusName: 'shade' }); }
  });

  /* ---------- Add to basket ---------- */
  let busy = false;
  function guide(selector, message) {
    const target = $(selector);
    if (target) {
      target.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'center' });
      const input = target.querySelector('input:not([disabled])');
      if (input) window.setTimeout(() => input.focus({ preventScroll: true }), reduce() ? 0 : 350);
    }
    status.classList.remove('is-error');
    status.textContent = message;
    if (!reduce()) { cta.classList.remove('is-nudge'); void cta.offsetWidth; cta.classList.add('is-nudge'); }
  }
  async function submit() {
    const m = ctaMode();
    if (m.mode === 'choose') { guide('[data-shade-field]', 'Choose your shade first.'); return; }
    if (m.mode === 'conc') { guide('[data-extra="set"]', 'Choose a concealer shade for your set.'); return; }
    if (m.mode === 'alt') { guide(`[data-extra="${state.tile}"]`, state.tile === '2' ? 'Choose the 2nd shade.' : `Choose the shade for ${NOUN[1]} 2 and 3.`); return; }
    if (m.mode !== 'add' || busy) return;
    if (!window.BISD || !window.BISD.add) { form.submit(); return; }
    busy = true;
    cta.classList.add('is-busy');
    cta.setAttribute('aria-busy', 'true');
    status.classList.remove('is-error');
    status.textContent = '';
    try {
      const cart = await window.BISD.add(m.q.items, { open: false });
      syncBag(cart);
      cta.classList.remove('is-busy');
      cta.classList.add('is-added');
      status.textContent = cart ? `Added. Basket total ${fmt(cart.total_price)}.` : 'Added to your basket.';
      window.setTimeout(() => window.BISD.openDrawer(), reduce() ? 0 : 420);
      window.setTimeout(() => { cta.classList.remove('is-added'); }, 1600);
    } catch (error) {
      cta.classList.remove('is-busy');
      status.classList.add('is-error');
      status.textContent = error && error.customer ? error.message : 'Connection problem. Your choices are saved. Please try again.';
    } finally {
      busy = false;
      cta.removeAttribute('aria-busy');
    }
  }
  if (form) form.addEventListener('submit', (event) => { event.preventDefault(); submit(); });

  /* The tiles price what you add; the basket prices everything in it. When the bag already has items, say so,
     so a "1 bottle" price is never read as the final basket price. Kept in step after adds, drawer edits and back/forward. */
  const bagHint = $('[data-bag-hint]');
  function syncBag(cart) {
    if (!bagHint || !cart || typeof cart.item_count !== 'number') return;
    const n = bagHint.querySelector('[data-bag-n]');
    if (n) n.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
    bagHint.hidden = cart.item_count === 0;
  }
  async function fetchBag() {
    if (!bagHint) return;
    try {
      const r = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (r.ok) syncBag(await r.json());
    } catch (error) { /* keep the server-rendered hint */ }
  }
  const bagDrawer = document.querySelector('[data-drawer]');
  if (bagDrawer) bagDrawer.addEventListener('close', fetchBag);
  window.addEventListener('pageshow', (event) => { if (event.persisted) fetchBag(); });

  /* Pairing "Add both" forms. Without JS they post the pairing alone to /cart/add. */
  el.addEventListener('submit', async (event) => {
    const pf = event.target.closest('[data-pair-form]');
    if (!pf || !window.BISD || !window.BISD.add) return;
    event.preventDefault();
    const btn = pf.querySelector('button[type="submit"]');
    if (btn.getAttribute('aria-busy') === 'true') return;
    const pairId = Number(pf.querySelector('[name="id"]').value);
    const p = cur();
    const items = state.picked && p && p.available ? [{ id: p.id, quantity: 1 }, { id: pairId, quantity: 1 }] : [{ id: pairId, quantity: 1 }];
    btn.setAttribute('aria-busy', 'true');
    let msg = pf.querySelector('[data-quick-status]');
    try {
      await window.BISD.add(items);
      if (msg) msg.textContent = '';
    } catch (error) {
      if (!msg) { msg = document.createElement('p'); msg.className = 'v2-quick-status'; msg.setAttribute('role', 'status'); msg.dataset.quickStatus = ''; pf.appendChild(msg); }
      msg.textContent = error && error.customer ? error.message : 'Something went wrong. Please try again.';
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  /* ---------- Sticky bar: only after the main button has scrolled away above ---------- */
  if (sticky && cta && 'IntersectionObserver' in window) {
    const show = (on) => {
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', String(!on));
      if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    };
    let ctaOut = false;
    let queued = false;
    const update = () => { queued = false; show(ctaOut && window.scrollY > 360); };
    new IntersectionObserver(([entry]) => { ctaOut = !entry.isIntersecting; update(); }).observe(cta);
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
    sticky.querySelector('[data-sticky-add]').addEventListener('click', () => {
      const m = ctaMode();
      if (m.mode === 'add' || m.mode === 'conc' || m.mode === 'alt') submit(); else guide('[data-shade-field]', 'Choose your shade first.');
    });
  }

  /* ---------- Start ---------- */
  const shadeParam = (params.get('shade') || '').toLowerCase().replace(/[.\s_]+/g, '-').replace(/[^a-z0-9-]/g, '');
  if (shadeParam) {
    const o = data.options.find((x) => x.key === shadeParam || x.o === shadeParam || x.c === shadeParam);
    if (o && o[state.f]) { state.picked = true; state.key = o.key; }
  }
  renderShades();
  renderConcealers();
  if (state.key !== data.current || !state.picked) {
    const p = cur();
    if (p) { syncUrl(p); renderGallery(p); }
  }
  const start = cur();
  if (start && !start.available && state.picked) {
    const tries = nearest(state.key, state.f, 2);
    note(`${opt(state.key) ? opt(state.key).name : 'This shade'} is sold out.${tries.length ? ' Try' : ''}`, tries);
  }
  renderAll();
})();
